import React from 'react';
import {IMultiSelectProps, ISelectProps, MultiSelectInput, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {TableSortDirection} from '~/components/Table';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {ID} from '~/lib/model';
import {sortByString} from '~/lib/sort';
import {fetchAgencies} from '~/modules/Clients/api';

type ISelectAgencyProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectAgency = ({
    disabled,
    ...props
}: ISelectAgencyProps) => {
    const {resource, isPending} = useResource(() => fetchAgencies(), []);

    return <SelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && <i className='fa fa-spinner fa-spin'/>}
        items={sortByString(resource.map(agency => ({
            label: agency.title,
            value: agency.id
        })), 'label', TableSortDirection.ASC)}/>;
};

export const SelectAgencyField = (props: IFieldProps<ISelectAgencyProps>) => <FormField {...props}>
    <SelectAgency {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;

type IMultiSelectAgencyProps = Omit<IMultiSelectProps<ID>, 'items'>;

export const MultiSelectAgency = ({
    disabled,
    ...props
}: IMultiSelectAgencyProps) => {
    const {resource, isPending} = useResource(() => fetchAgencies(), []);
    return <MultiSelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && <i className='fa fa-spinner fa-spin'/>}
        items={sortByString(resource.map(agency => ({
            label: agency.title,
            value: agency.id
        })), 'label', TableSortDirection.ASC)}/>;
};

export const MultiSelectAgencyField = (props: IFieldProps<ISelectAgencyProps>) => <FormField {...props}>
    <MultiSelectAgency {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
